import { useCallback, useEffect, useState } from 'react';
import { PlanType, listPlanTypes } from '../api/plantype';

// 方案类型的公共取数层 (参数管理表单 / 参数列表预览 / 方案类型管理页共用).
// 启用项全量只有几十行, 做模块级缓存 (全站一次请求); 管理页增删改后调 invalidatePlanTypes() 让已挂载的订阅者重拉.

let cache: PlanType[] | null = null;
let inflight: Promise<PlanType[]> | null = null;
const listeners = new Set<() => void>();

function fetchEnabled(): Promise<PlanType[]> {
    if (cache) return Promise.resolve(cache);
    if (!inflight) {
        inflight = listPlanTypes()
            .then((list) => {
                cache = list || [];
                return cache;
            })
            .finally(() => {
                inflight = null;
            });
    }
    return inflight;
}

/** 方案类型增删改 (含设备绑定) 后调用: 清缓存并让所有已挂载的 usePlanTypes 重新拉取. */
export function invalidatePlanTypes() {
    cache = null;
    inflight = null;
    listeners.forEach((fn) => fn());
}

/** 启用中的方案类型 (指定架构; archCode 空 = 全部). 失败静默给空列表. */
export function usePlanTypes(archCode: string): PlanType[] {
    const [all, setAll] = useState<PlanType[]>(cache || []);
    useEffect(() => {
        let alive = true;
        const load = () =>
            fetchEnabled()
                .then((l) => alive && setAll(l))
                .catch(() => alive && setAll([]));
        load();
        listeners.add(load);
        return () => {
            alive = false;
            listeners.delete(load);
        };
    }, []);
    return archCode ? all.filter((p) => p.archCode === archCode) : all;
}

/** code → 展示名 (指定架构); 未命中回退原 code. 参数列表预览等只读场景用, 不按设备过滤. */
export function usePlanTypeText(archCode: string): (code?: string) => string {
    const list = usePlanTypes(archCode);
    return useCallback(
        (code?: string) =>
            code ? list.find((p) => p.code === code)?.label || code : '',
        [list],
    );
}
